import { render } from "./StudentDataTable.vue?vue&type=template&id=d63b4808&scoped=true"
import script from "./StudentDataTable.vue?vue&type=script&lang=js"
export * from "./StudentDataTable.vue?vue&type=script&lang=js"

import "./StudentDataTable.vue?vue&type=style&index=0&id=d63b4808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63b4808"]])

export default __exports__